import { z } from 'zod';
import { BLOCKED_SYNC_ROUTES, router } from '@/router.ts';

const RouteChangeValueSchema = z.object({
    path: z.string(),
});

export const routeChangeHandler = (rawValue: object) => {
    const value = RouteChangeValueSchema.parse(rawValue);

    const path = value.path;

    for (const blockedRoute of BLOCKED_SYNC_ROUTES) {
        if (path.includes(blockedRoute)) {
            return;
        }
    }

    void router.push(path);
};
